import styled from 'styled-components';

export const MenuButton = styled.button`
  border: none;
  outline: none;
  background: transparent;
`;
